import SelectStoreRedirect from './SelectStoreRedirect'

export default SelectStoreRedirect
